import React, { useState } from "react";
import "./SignUp.scss";
import "react-phone-input-2/lib/style.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PhoneInput from "react-phone-input-2";
import { motion, AnimatePresence } from "framer-motion";
import { registerUser } from '../services/apiUsers';
import { useNavigate } from "react-router-dom";

export default function SignUp() {
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);

  const validateStep1 = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "Le nom est requis";
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      newErrors.email = "Email invalide";
    if (!form.phone || form.phone.length < 8)
      newErrors.phone = "Numéro de téléphone invalide";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};
    if (form.password.length < 6)
      newErrors.password = "Le mot de passe doit contenir au moins 6 caractères";
    if (form.password !== form.confirmPassword)
      newErrors.confirmPassword = "Les mots de passe ne correspondent pas";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validateStep1()) setStep(2);
  };

  const handleBack = (e) => {
    e.preventDefault();
    setStep(1);
  };
/*
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateStep2()) {
      console.log("Formulaire envoyé :", form);
      alert("Inscription réussie !");
    }
  };
*/
async function handleSubmit(e) {
    e.preventDefault(); // ⚠️ très important pour bloquer le rechargement de page
  
    try {
      if (validateStep2()) {
        const payload = {
          nom: form.name,
          phone: form.phone,
          email: form.email,
          password: form.password,
          categorie:0,
        };
  
  
        const data = await registerUser(payload);
        console.log("✅ response data :", data);
        if (data) {
            showToast("Inscription réussie 🎉", "success");
    
            // redirection après 1.5s
            setTimeout(() => {
                navigate("/");
            }, 1500);
          } else {
            showToast("Une erreur est survenue", "error");
          }
  
        // ici tu peux rediriger ou afficher une confirmation
      }
    } catch (err) {
      console.error("❌ Erreur lors de l'inscription :", err.response?.data || err.message);
    }
  }
  
  const showToast = (message, type) => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 5000); // disparaît après 2,5s
  };


  const slideVariants = {
    initial: (direction) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0,
    }),
    animate: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeInOut" },
    },
    exit: (direction) => ({
      x: direction < 0 ? 100 : -100,
      opacity: 0,
      transition: { duration: 0.4 },
    }),
  };

  return (
    <div className="signup-container">
      <div className="signup-background"></div>
      <div className="signup-overlay"></div>
        <div className="login-logo">
            <img src='./images/mobing.png' className='logo' alt='mon-image' />
        </div><br/>

      <div className="signup-form">

        <h1>{step === 1 ? "Créer un compte" : "Sécurité du compte"}</h1>

        <AnimatePresence mode="wait" initial={false} custom={step}>
          {step === 1 && (
            <motion.form
              key="step1"
              variants={slideVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              custom={1}
              onSubmit={handleNext}
            >
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Nom complet"
                  value={form.name}
                  onChange={(e) =>
                    setForm({ ...form, name: e.target.value })
                  }
                />
                {errors.name && (
                  <span className="error">{errors.name}</span>
                )}
              </div>

              <div className="form-group">
                <PhoneInput
                  country={"cd"}
                  value={form.phone}
                  onChange={(phone) => setForm({ ...form, phone })}
                  inputStyle={{
                    width: "100%",
                    background: "#333",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    height: "48px",
                    paddingLeft: "58px",
                  }}
                  buttonStyle={{
                    background: "#333",
                    border: "none",
                    borderRight: "1px solid #444",
                  }}
                  dropdownStyle={{
                    backgroundColor: "#222",
                    color: "white",
                  }}
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Adresse e-mail"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
                {errors.email && <span className="error">{errors.email}</span>}
              </div>

              <div className="form-buttons">
                <button type="submit" className="btn-signup">
                  Suivant
                </button>
              </div>
            </motion.form>
          )}

          {step === 2 && (
            <motion.form
              key="step2"
              variants={slideVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              custom={-1}
              onSubmit={handleSubmit}
            >
              <div className="form-group password-group">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Mot de passe"
                  value={form.password}
                  onChange={(e) =>
                    setForm({ ...form, password: e.target.value })
                  }
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                </span>
                {errors.password && (
                  <span className="error">{errors.password}</span>
                )}
              </div>

              <div className="form-group password-group">
                <input
                  type={showPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirmer le mot de passe"
                  value={form.confirmPassword}
                  onChange={(e) =>
                    setForm({ ...form, confirmPassword: e.target.value })
                  }
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                </span>
                {errors.confirmPassword && (
                  <span className="error">{errors.confirmPassword}</span>
                )}
              </div>

              <div className="form-buttons">
                <button
                  type="button"
                  className="btn-back"
                  onClick={handleBack}
                >
                  ⬅ Précédent
                </button>
                <button type="submit" className="btn-signup">
                  S’inscrire
                </button>
              </div>

              <p className="login-link">
                Déjà inscrit ? <a href="/login">Se connecter</a>
              </p>
            </motion.form>
          )}
        </AnimatePresence>
      </div>

      {/* 🧨 Toast Netflix-style */}
      <AnimatePresence>
        {toast && (
          <motion.div
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 80, opacity: 0 }}
            transition={{ type: "spring", stiffness: 120, damping: 12 }}
            className={`fixed bottom-6 left-1/2 -translate-x-1/2 px-6 py-3 rounded-xl shadow-lg text-white font-medium ${
              toast.type === "success" ? "bg-green-500" : "bg-red-500"
            }`}
          >
            {toast.message}
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
}
